import { BillingUsageGroup } from 'services/repositories/billing/billing';

import { FeaturesBreakdownTable } from './FeaturesBreakdownTable';

export const renderModuleBreakdown = (group: BillingUsageGroup) => {
  if (group.features.length > 0) {
    return <FeaturesBreakdownTable features={group.features} />;
  }
  return null;
};
